module.exports = __webpack_public_path__ + "img/brithDay.fc16828a.png";